import { useRouteMatch } from "@/compat/router";
import moduleAreas, { moduleUrls } from "../../constants/moduleAreaConstants";
import TemplateBuilder from "./TemplateBuilder";
import RiskAssessmentTemplateBuilder from "./RiskAssessmentTemplateBuilder";

/**
 * Dispatches the shared /setup/:moduleArea/templatebuilder route to the right
 * builder. Risk Assessments use the single-view builder; every other module
 * (Incidents, Monitoring, Compliance) stays on the legacy stepper.
 */
export default function TemplateBuilderRouter() {
    const { params } = useRouteMatch();
    const moduleArea = parseInt(
        Object.keys(moduleUrls).find((key) => moduleUrls[key] === params.moduleArea) ?? ""
    );

    if (moduleArea === moduleAreas.RISKASSESSMENTS) return <RiskAssessmentTemplateBuilder />;
    return <TemplateBuilder />;
}
